export default __webpack_public_path__ + "static/N0101-bc2106bae63c1dbab8d86cef7b99d805.png";